"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorityEditCell = void 0;
const react_1 = __importDefault(require("react"));
const Flag_1 = __importDefault(require("@mui/icons-material/Flag"));
const priority_edit_cell_styles_1 = require("./priority-edit-cell.styles");
const priority_constants_1 = require("./priority.constants");
const table_cells_1 = require("../../../../common/table-cells");
const renderPriorityOption = (option) => {
    var _a;
    return (react_1.default.createElement(priority_edit_cell_styles_1.StyledPriorityOptionContent, null, react_1.default.createElement(priority_edit_cell_styles_1.StyledPriorityOption, null, react_1.default.createElement(Flag_1.default, { className: "priority-flag-icon", sx: { color: (_a = priority_constants_1.PRIORITY_COLOR_CONFIG[option.value]) === null || _a === void 0 ? void 0 : _a.color } })), react_1.default.createElement(priority_edit_cell_styles_1.StyledPriorityOptionLabel, null, option.label)));
};
const PriorityEditCell = ({ id, field, value, options, }) => (react_1.default.createElement(table_cells_1.AutocompleteEditCell, { id: id, field: field, value: value, options: options, renderOption: renderPriorityOption, renderValue: renderPriorityOption }));
exports.PriorityEditCell = PriorityEditCell;
